import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import AppWrapper from './App';
import reportWebVitals from './reportWebVitals';
import { useStore } from './store';

import 'antd/dist/reset.css';
import 'assets/css/index.scss';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

function Root() {
  const store = useStore();
  return (
    <Provider store={store}>
      <AppWrapper/>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);

reportWebVitals();
